import React from 'react';
import ForgotPassword from "./components/auth/forgotPassword";
import Register from "./components/auth/register";
import {Authenticated, RouteWithoutLayout} from 'react-admin';
import ControlEmail from "./components/auth/controlEmail";
import HomePage from "./components/HomePage";
import {Route} from "react-router-dom";
import {ProfileEdit} from "./components/ProfileEdit";
import {ImportCsv} from "./components/seller/ImportCsv";
import Label from "./components/label";

const routes = [
    <RouteWithoutLayout exact path="/service/forgot-password/:id" component={ForgotPassword}/>,
    <RouteWithoutLayout exact path="/service/forgot-password" component={ControlEmail}/>,
    <RouteWithoutLayout exact path="/register" component={Register}/>,
    <Route
        key="my-profile"
        path="/my-profile"
        render={() => <ProfileEdit/>}
    />,
    <Route
        key="import-csv"
        path="/import-csv"
        component={ImportCsv}
    />,
    <Route exact path="/dashboard" render={() =>
        <Authenticated>
            <HomePage/>
        </Authenticated>
    }/>,
];

export default routes;